import BaseDocumentEntity from '@/entity/BaseDocumentEntity';
import useDocumentService from '@/services/DocumentService';
import { Reactive } from '@/utils/decorators';
import BaseSetup from '../BaseSetup';

export type SharedListDocumentItemActionsEmits = {
	(e: 'select'): void
	(e: 'update:tagOpened', val: boolean): void
};
export type SharedListDocumentItemActionsProps = {
	selected?: boolean
	tagOpened?: boolean
	entity: BaseDocumentEntity<Armado.ArmadoDocument>
	actions?: DocumentItemAction[]
};

export default class SharedListDocumentItemActionsSetup extends BaseSetup {

	static readonly defaultProps = {
		actions: () => [
			'visualize',
			'download',
			'tag',
			'select',
		] as DocumentItemAction[],
	};

	private readonly documentService: ReturnType<typeof useDocumentService>;

	@Reactive private readonly state = { tagSelectOpen: false };

	private get routeIsDetails () { return !!this.router.currentRoute.value.name && /Details$/.test(this.router.currentRoute.value.name.toString()) }

	get tagSelectOpen () { return this.state.tagSelectOpen }
	set tagSelectOpen (val) {
		this.state.tagSelectOpen = val;
		this.emits('update:tagOpened', val);
	}

	constructor (
		private props: SharedListDocumentItemActionsProps,
		private emits: SharedListDocumentItemActionsEmits,
	) {
		super();
		this.documentService = useDocumentService(this.self.userType, this.props.entity.documentType);
	}

}
